import React, { useState, useEffect } from "react";
import "./contactUs.css";
import iconChat from "assets/common/icon_chat.svg";
import iconLocation from "assets/common/icon_location.svg";
import iconCall from "assets/common/icon_call.svg";
import Meta from "utils/meta";

const ContactUs = () => {
  const [emailError, setEmailError] = useState("");
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    about_us: "",
  });

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(email)) {
      setEmailError("Please enter a valid email address.");
      return false;
    } else {
      setEmailError("");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (name === "email") {
      validateEmail(value);
    }
  };

  const handleSendEmail = (e) => {
    e.preventDefault();
    const contactFormData = {
      ...formData,
    };
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (<div className="container">
      <Meta title="Contact US | The Realtor Desk" description="" />
      <div className="contactUs-container">
        <div className="contactUs-left">
          <div className="contactUs-left-detail">
            <div className="contactUs-icon">
              <img src={iconChat} alt="Chat to us" />
            </div>
            <div className="contactUs-context">
              <h4>Chat to us</h4>
              <p>Our friendly team is here to help</p>
              <h3>operations@therealtordesk.com</h3>
            </div>
          </div>
          <div className="contactUs-left-detail">
            <div className="contactUs-icon">
              <img src={iconLocation} alt="Visit us" />
            </div>
            <div className="contactUs-context">
              <h4>Visit us</h4>
              <p>Come say hello at our HQ office!</p>
              <h3>
                406 - The Baroda Crossway, Opp. Police Bhavan , Jail Rd Vadodara
                Gujarat - India
              </h3>
            </div>
          </div>
          <div className="contactUs-left-detail">
            <div className="contactUs-icon">
              <img src={iconCall} alt="Call us" />
            </div>
            <div className="contactUs-context">
              <h4>Call us</h4>
              <p>Mon-Fri from 10am to 6pm</p>
              <h3> +91 8866550550</h3>
            </div>
          </div>
        </div>
        <div className="contactUs-right">
          <h1>Got ideas? we've got the skills. Let's team up.</h1>
          <p>Tell us more about yourself and what you're got in mind</p>
          <form
            className="contactUs-form"
            onSubmit={handleSendEmail}
            noValidate
          >
            <div className="contactUs-form-row">
              <label htmlFor="full_name">
                <div>Full Name<span style={{ color: "red" }}>*</span></div>
              </label>
              <input
                type="text"
                placeholder="Enter your name"
                name="full_name"
                value={formData.full_name}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="contactUs-form-row">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                placeholder="you@company.com"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
              {emailError && (
                <p className="inq-error-message" style={{ color: "red" }}>
                  {emailError}
                </p>
              )}
            </div>
            <div className="contactUs-form-row">
              <label htmlFor="about_us">Message</label>
              <textarea
                placeholder="Tell us a little about the thoughts.."
                name="about_us"
                value={formData.about_us}
                onChange={handleInputChange}
                required
              />
            </div>
            <button className="contactUs-next-btn primary" type="submit">
              Let's get started!
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
